export const TranslationsZH = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: "网上订购",
        cart: "购物车",
        open_24: "24 小时",
        closed: "已下班",
        free: "免费",
        something_went_wrong: "出问题了",
        try_again: "再试一次",
    },
    constants: {
        calendar: {
            days: {
                monday: "星期一",
                tuesday: "星期二",
                wednesday: "星期三",
                thursday: "星期四",
                friday: "星期五",
                saturday: "星期六",
                sunday: "星期日",
            },
        },
        services: {
            pickup: "到店自提",
            delivery: "外卖配送",
            dine_in: "堂食",
            table_booking: "订座",
        },
        payment: {
            method: {
                cash: "现金",
                card: "银行储蓄卡",
                stripe: "信用卡",
                paypal: "PayPal",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                custom: "定制",
            },
            backend_method: {
                cash: "现金",
                card: "银行储蓄卡",
                stripe: "Card/Wallet",
                paypal: "PayPal",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                custom: "定制",
            },
            status: {
                success: "支付成功",
                pending: "等待支付",
                error: "错误",
                refunded: "已退款",
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: "删除",
                drop_here: "把您的文件放在这里或者点击选择一个",
                accepts: "接受 {{fileTypes}} 文件",
                errors: {
                    max_files: "可允许的最多文件数目 {{number}} ",
                    max_size: "最大的文件大小 {{kilobytes}} KB",
                },
            },
        },
    },
    // UI
    store: {
        global: {
            buttons: {
                order: {
                    book_order: '订座 / 网上订购',
                    order_online: '网上订购',
                    book_table: '订座',
                    order: '订购',
                    book: '订座',
                    cart: '购物车',
                    restart: '重新开始',
                    closed: '营业时间已过',
                    not_accepting: '不接受订单',
                },
            },
        },
        modals: {
            auth: {
                login: '登录',
                register: '注册',
                register_commence: '继续',
                register_complete: '创建帐户',
                register_confirmation_sent: '确认码已经发送到您的电子邮箱地址。请在下面输入以继续',
                register_confirmation_resent: '确认码已再次发送，请检查您的垃圾邮件或重新操作',
                register_restart: '重新开始',
                register_resend_code: '重发确认码',
                login_placeholder: '电子邮箱',
                password_placeholder: '密码',
                confirmation_code_placeholder: '电子邮箱确认码',
                accept_terms: '接受条款及细则',
                accept_terms_view: '查看',
                login_facebook: '通过Facebook登录',
                login_google: '通过Google登录',
                benefits: '登录或创建一个帐户来保存您所有的订单',
                logged_in: '成功登录',
                logged_out: '退出',
                error_generic: '如有问题，请再试一次或者联系我们',
                error_accept_terms: '请接受条款及细则',
                error_password_length: '密码最少6个字符',
                error_social: '如有问题，再试一次或者联系我们',
                error_confirmation_code: '确认码无效',
                error_invalid_code: '确认码无效',
                error_exists: '用户已存在',
                error_invalid_email_pass: '电子邮箱地址或者密码无效',
            },
            booking: {
                form: {
                    name: '全名',
                    email: '电子邮箱地址',
                    phone: '电话号码',
                    number_of_people: '人数',
                    number_of_people_limit: '最多人数 ({{people}})',
                    notes: '注释/特别要求',
                    submit: '提交订座要求',
                    email_optional: '（可选）',
                    date: '日期',
                    duration: '时长',
                    seating: '可预订时间',
                    number_of_guests: '人数',
                    notes_placeholder: '过敏、场合、座位偏好',
                    reserving: '正在预订...',
                    reserve_table: '预订桌位',
                    please_choose_a_date_and_time: '请选择日期和时间。',
                    invalid_people: '人数须在 {{min}} 到 {{max}} 之间。',
                    party_size_max_fallback: '允许的上限',
                    loading_available_times: '正在加载可预订时间…',
                    select_a_date_to_see_available_times: '选择日期以查看可预订时间。',
                    no_times_available_for_this_date: '该日期没有可预订时间，请选择其他日期。',
                    shift: '时段',
                    service_times: '营业时段',
                    new_shift: '新时段',
                    time: '个时段',
                    times: '个时段',
                    unavailable: '已满',
                    available: '可预订',
                    required_name: '请输入您的姓名。',
                    required_phone: '请输入您的电话号码。',
                    required_email: '请输入您的电子邮箱。',
                    invalid_email: '请输入有效的电子邮箱。',
                    required_terms: '预订前请接受条款。',
                    missing_custom_fields: '请完成所有必填问题。',
                    reservation_is_unavailable: '暂不接受预订。',
                    please_contact_the_restaurant_directly: '请直接联系餐厅。',
                    almost_done: '即将完成',
                    your_details: '您的信息',
                    tell_us_who_s_coming: '请告诉我们来客信息，以便确认您的预订。',
                    book_your_table: '预订您的桌位',
                    choose_a_time_that_works_for_you: '选择一个适合您的时间。',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: '提交预订请求，其余事宜由餐厅处理。',
                    select_date: '选择日期',
                    standard: '标准',
                    minutes: '分钟',
                    next: '下一步 →',
                    back: '← 返回',
                    accept_terms: '我接受条款和条件。',
                    info_1: '当您的订座要求被接受或拒绝时，您将收到一封电子邮件通知',
                },
                errors: {
                    not_found: '预订不存在，可能被删除了',
                    generic: '如果有问题，请刷新页面或与我们联系',
                    something_went_wrong: '出问题了',
                    accept_terms: '请接受条款及细则',
                    required_phone: '请输入您的电话号码',
                    required_email: '请输入您的电子邮箱地址',
                    required_name: '请输入您的姓名',
                    invalid_email: '请输入一个有效的电子邮箱地址',
                    booking_capacity_threshold: "该时间已订满，请尝试其他时间。",
                    slot_unavailable: "该人数已订满，请尝试其他时间。",
                    booking_date_paused: "该日期已暂停预订，请选择其他日期。",
                    invalid_table_assignment: "这些桌位无法容纳您的人数，请选择其他时间。",
                    exceeded_order_limit: "预订请求过多，请稍后再试。",
                    validation_failed_recaptcha_v3: "检测到异常流量。您是否在使用 VPN？请完成上方验证后重试。",
                    validation_failed_recaptcha_v2: "无法开始预订。请重试或使用其他方式。如果您在使用 VPN，请先关闭。",
                    booking_already_exists: "该预订已提交。请查看您的电子邮件或打开预订链接。",
                    invalid_party_size: "请选择有效的人数。",
                    invalid_request: "请求无效。请刷新页面后重试。",
                    table_booking_unavailable: "桌位预订不可用。",
                },
            },
            cart: {
                title: '购物车',
                proceed_to_checkout: '进入结算',
                edit_dish: '编辑',
                remove_dish: '删除',
                no_items_1: '购物车内无商品',
                no_items_2: '请先添加商品以继续',
                free_delivery_notice: '免配送费订购金额 {{value, currency}}',
                errors: {
                    min_order_promo: '在使用此优惠前，购物车最低金额为 {{value, currency}} ',
                    min_order_delivery: '购物车最低起送金额 {{value, currency}} ',
                },
                promo: {
                    heading: '优惠码',
                    placeholder: '输入您的优惠码',
                    add: '添加优惠码',
                    title: '添加到购物车的优惠活动名称 {{name}} ',
                    fixed_discount: '优惠 {{value, currency}} ',
                    percent_discount: '优惠 {{value}}% ',
                    added_to_cart: '添加到购物车的优惠',
                    errors: {
                        not_found: '没有找到优惠',
                        disabled: '优惠活动已停止',
                        not_available: '暂无优惠活动',
                        logged_in_only: '必须登录才能使用这个优惠',
                        already_used: '您已经使用过这个优惠',
                        invalid: '此优惠不再有效',
                        invalid_service: '此优惠不适用于您所选择的服务',
                        generic: '哦... 出问题了，已经登录过了',
                        dishes_required_multi: '此优惠只适用于指定菜名被加入到您的购物车时',
                        dishes_required_single: "此优惠只适用于 '{{dish}}'",
                    },
                },
                tip: {
                    title: '订单小费',
                    placeholder: '添加订单小费',
                },
            },
            checkout: {
                title: '结账',
                subtitle: '确认您的订单',
                details: {
                    service: '服务',
                    due: 'Due',
                    due_now_asap: '马上/尽快',
                    address: '配送地址',
                    total: '总金额',
                    table: '桌子',
                    store_location: '商家地址',
                },
                customer: {
                    title: '用户',
                    subtitle: '登录以保存您的订单和详细信息',
                    button: '登录',
                    name: '全名',
                    email: '电子邮箱地址',
                    phone: '电话号码',
                    phone_important: '电话号码 (重要)',
                    notes: '订单备注',
                    delivery_notes: '配送说明 / 订单备注',
                    optional: '可选',
                },
                payment: {
                    title: '支付方式',
                },
                accept_terms: '接受条款及细则',
                accept_terms_view: '查看',
                processing_order: '处理订单中',
                warning: {
                    different_payment_currency: '商店价格货币是 {{store_currency}} 但是支付方式货币是 {{payment_currency}}',
                    closing_soon: '营业就快结束，请必须在 {{value}} 分钟内订购',
                    closed: '抱歉，服务已经停止，暂不接受订单',
                    expired: '我们不能在您指定的时间完成您的订单，请选择往后的日期或时间',
                },
                errors: {
                    stripe_generic: '信用卡错误，请重试或用其他方法',
                    stripe_loading_fail: '下载付款格式错误，请重试',
                    something_went_wrong: '出问题了',
                    paypal_generic: 'PayPal出了问题，再试一次或者选择另一种支付方式',
                    payment_fail: '付款失败，请重试或选择其他付款方式',
                    payment_cancelled: '已取消付款，请重试或选择其他付款方法',
                    payment_error: '在线支付错误，请重试或选择另一种付款方法',
                    card_declined: '您的信用卡被拒绝，无法处理付款',
                    promo_max_uses_exceeded: "此促销代码已达到使用上限，无法再使用。",
                    store_closed: '商店已到下班时间，不再接受订单',
                    accept_terms: '请接受条款及细则',
                    required_payment: '请选择付款方式',
                    required_phone: '请输入您的电话号码',
                    required_email: '请输入您的电子邮箱地址',
                    required_name: '请输入您的名字',
                    invalid_email: '请输入一个有效的电子邮箱地址',
                    invalid_phone: '请输入一个有效的电话号码',
                    invalid_order_amount: '此付款方式所需的最低金额',
                    closed: '商店就快关门/关门了，不再接受订单',
                    promo_login_required: '必须登录才能使用这个优惠码',
                    promo_used: '您已经使用过这个优惠',
                    exceeded_order_limit: '我们目前收到很多订单。请稍后选择一个时间。',
                    exceeded_order_limit_later: "我们无法在您选择的时间履行订单。请您选择一个更晚的日期或时间。",
                },
                button: {
                    continue: '继续付款',
                    place_order: '下订单',
                },
            },
            customer: {
                age_v: {
                    title: '年龄验证',
                    required_for_items: '需要订购特定商品',
                    min_age: '最低年龄: {{age}} 岁',
                    est_time: '估计验证时间: {{time}} 小时',
                    upload_description: '上传您的身份证件。一经核实，我们将通过电子邮件通知您。最多上传2张图片，每张图片的最大尺寸为2 MB',
                    pending_description_1: '谢谢您提交文件。当您获得批准时，您将收到电子邮件通知',
                    pending_description_2: '刷新页面以更新您的验证状态。估计验证时间 {{time}} 小时',
                    approved_description: '您的帐户已经通过验证，您可以从受限制的菜单点菜',
                    rejected_description: '您的身份证件已被拒绝。如果您想再试一次，请重新上传您的身份证件',
                    upload: '上传',
                    reupload: '重新上传文件',
                    go_back: '返回',
                    view_document: '查看文件 {{number}}',
                    status: {
                        unverified: '未验证',
                        pending: '等待批准',
                        approved: '成功验证',
                        rejected: '拒绝',
                    },
                },
                headings: {
                    sessions: '浏览次数',
                    orders: '订单',
                    spend: '已消费',
                    order_history: '订单历史',
                    loyalty_points: '忠诚度积分',
                },
            },
            dish: {
                add: '加入购物车',
                edit: '更新选项',
                notes: '备注',
                ingredients: {
                    title: '配料',
                    uncheck_remove: '取消勾选项',
                },
                ingredients_title: '配料',
                combo: {
                    choose_dish: '选择一个菜名',
                },
                option_sets: {
                    conditions: {
                        select_one: '选择一个(必选)',
                        select_one_optional: '选择一个(可选)',
                        select_between: '选择 {{min}} - {{max}} (必选)',
                        select_at_least: '至少选择 {{qty}} (必选)',
                        select_up_to: '最多可选择 {{qty}} (可选)',
                        select_multiple: '选择多个 (可选)',
                        free_amount: '前 {{qty}} 免费 / {{selected}} 选择',
                    },
                },
                error: '请更正任何红色标记的选项',
                added_to_cart: '购物车清单',
            },
            map: {
                zone_fee: '配送费',
                view_in_google: '在 Google 地图查看',
            },
            portal_go_back: {
                title: '返回到<搜索餐馆>?',
                description: '您购物车中的所有选项都将丢失',
                cancel: '取消',
                proceed: '返回',
            },
            order: {
                config: {
                    services: {
                        title: '选择服务',
                        table_booking: '订座',
                    },
                    address_custom: {
                        input_placeholder: '输入您的地址',
                    },
                    address: {
                        input_placeholder: '寻找您的送货地址',
                        extras_placeholder: '可选:单位编号、建筑名称等',
                        search_placeholder: '搜索您的地址',
                        not_found: '配送地址未找到或无效，请重试',
                        not_delivering: '我们目前没有配送到这个地址',
                        not_in_range: '您的地址不在我们商家的营业范围内',
                        not_in_zone: '您的地址不在活动配送区域内',
                        location_permission: '允许此网站访问您的当前位置吗？',
                        location_permission_warning: '无法访问您的当前位置。 请在您的设备和网络浏览器上启用定位服务。 这里有一些参考：',
                        pick_location: '选择您的位置',
                        pick_location_help_text: '拖动标记以选择地图上的位置。',
                        use_current_location: '使用当前位置',
                        locate_on_map: '在地图上定位',
                    },
                    datetime: {
                        title: '您想点什么时候的餐',
                        due_now: '现在',
                        due_later: '稍后',
                        service_not_available: '抱歉，我们目前不接受 {{service}}订单',
                        currently_closed: '{{service}} 目前关闭，但您可以预订下一天的餐',
                        due_unavailable: '暂不提供',
                        due_closed: '非营业时间',
                        select_date: '选择日期',
                        select_time: '选择时间',
                        select_order_date: '选择您的订单日期',
                        select_order_time: '选择您的订单时间',
                        select_order_date_time: '选择您的订单日期/时间',
                        select_booking_date: '选择您的订座预留日期',
                        select_booking_time: '选择您的订座预留时间',
                        no_times_available: '没有订座时间可供选择',
                        date_today: '(今天)',
                        date_closed: '(关闭)',
                        date_bookings_paused: '（预订已暂停）',
                        time_slot_closed: '关闭',
                    },
                    number_of_people: {
                        placeholder: '人数',
                    },
                    table: {
                        select: '选择桌子',
                        select_popup_title: '选择您的桌子',
                        password: '桌子密码',
                        password_warning: '输入您的桌子密码',
                    },
                    warning: {
                        closed: '抱歉，我们现在是非营业时间/不接受任何订单',
                        not_available: '抱歉，我们目前不接受任何订单',
                    },
                    start_button: '开始订单',
                },
                history: {
                    invalid: '因为一些订购的项目已被修改或不可再用，不可重新订购。',
                },
                reorder: {
                    title: '快速重新订购',
                    description: '从您以前的订单中轻松再订购',
                },
            },
            receipt: {
                errors: {
                    not_found: '订单不存在,可能被删除了。',
                    booking_not_found: '预订不存在，可能已被删除',
                    generic: '如果有问题，请刷新页面或与我们联系。',
                },
                connection: {
                    connected: '实时更新',
                    connecting: '连接实时更新',
                    disconnected: '断接实时更新',
                },
            },
            warnings: {
                logout: {
                    pretitle: '警告',
                    title: '退出',
                    body: '退出将删除添加到购物车中的任何项目',
                    cancel: '取消',
                    proceed: '继续',
                },
                order_restart: {
                    warning: '警告',
                    title: '更改订单细节',
                    body: '更改您的订单细节将可能导致您购物车中的菜品被删除和某些菜品可能变得不可用。',
                    cancel: '取消',
                    proceed: '继续',
                },
                order_expired: {
                    subtitle: '重要',
                    title: '更改订单为立即到期',
                    description: '您的订单时间即将结束，所以您的订单已被修改为立即到期/尽快。',
                    button: 'Ok',
                },
                order_expiring: {
                    subtitle: '重要',
                    title: '订单截止日期即将到期',
                    description: '避免失效，请您必须在 {{time, timeFromTimestamp}} 之前下订单',
                    button: 'Ok',
                },
                location_permission: {
                    cancel: '取消',
                    proceed: '继续',
                },
            },
            maps: {
                cancel: '取消',
                use_location: '使用地点',
            },
        },
        sections: {
            nav_top: {
                guest: "客人",
                login_signup: "登录 / 注册",
                logout: "退出",
            },
            menus: {
                info: {
                    no_menus: "目前没有可用菜单",
                    restrictions: "菜单限制",
                    not_available: "菜单暂不可用",
                    unavailable: {
                        times: "菜单暂不可用，您的订单要求与下面不匹配",
                        services: "菜单暂不可用，您的订单要求与下面不匹配",
                        hours: "菜单暂不可用，您的订单时间不在此菜单的可用时间内",
                        pre_order: "菜单暂不可用，您的订单与预订要求不匹配。",
                        age: "菜单暂不可用，您必须以已经通过年龄验证的帐户登录，然后再从该菜单订购",
                    },
                    services: {
                        title: "订购要求",
                        pickup: "自提",
                        delivery: "配送",
                        dine_in: "堂食",
                    },
                    times: {
                        now: "没有预订",
                        later: "只接受预订",
                    },
                    hours: {
                        title: "可选时间",
                    },
                    preorder: {
                        title: "预订需求",
                        days_in_advance: "必须提前 {{days}} 天订购",
                        cutoff_time: "截至时间为 {{time, timeFromTime}}",
                    },
                    age_restricted: {
                        title: "年龄限制",
                        approved: "您的帐户已经过验证，您可以从此菜单订购。",
                        rejected: "需要年龄验证才能订购。请创建一个帐户并上传您的身份证件。",
                    },
                },
            },
            info: {
                location: {
                    title: "地点",
                    view_map: "查看地图",
                    phone: "电话",
                },
                hours: {
                    title: "营业时间",
                    title_special: "特殊营业时间",
                },
                services: {
                    title: "服务",
                    notes: "备注",
                    delivery: {
                        ranges: "配送范围",
                        zones: "配送区域",
                        view_zones: "在地图查看区域",
                        fee: "配送费",
                        fee_short: '费',
                        min_order: "最低订购金额",
                        min_order_short: '最低单',
                        no_min_order: "没有最低订购金额",
                        free_amount: "免费配送金额",
                    },
                },
            },
            contact: {
                title: "联系我们",
                name: "名字",
                email: "电子邮箱",
                phone: "电话号码",
                message: "输入您的消息...",
                send: "发送消息",
                success: "您的消息已发送成功",
                error: "出问题了，请再试一次或稍后再试",
            },
            footer: {
                powered_by: "平台拥有和运营：",
                terms_and_conditions: "条款及细则",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: '订座收据',
            details: {
                datetime: '预订时间',
                number_of_people: '人数',
                placed: '预订',
                updated: '最后更新',
                notes: '备注',
                name: '名字',
                email: '电子邮箱',
                phone: '电话',
                store_address: '商店地址',
            },
            status_update: {
                title: '预订号码 {{number}} 已更新',
                body: '您的预订状态已更新为 {{status}}',
            },
            email_status_update_customer: {
                subject: '预订 #{{number}} – {{subjectLabel}}',
                body: '您在 {{store}} 的预订 #{{number}} 现为{{status}}。',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: '订单 #{{number}} – {{subjectLabel}}',
        header: '取餐时间已更新',
        title: '取餐时间已更新',
        order_number: '订单号: {{number}}',
        description: '您的订单将于 {{time}} 准备好。',
        order_time_updated_to: '您的订单时间已更新。',
        powered_by: '供电 {{name}}',
        button_text: '跟踪订单',
        subject_label: '取餐时间已更新',
        subject_label_delivery: '送达时间已更新',
        body_ready: '您的订单将于 {{time}} 准备好。',
        body_delivery: '您的订单将于 {{time}} 送达。',
    },
    order: {
        receipt: {
            est_ready_time: '预计食物准备时间',
            est_delivery_time: '预计配送时间',
            tab_details: '详情',
            tab_dishes: '菜品',
            details: {
                placed: '已下单',
                due: '现在',
                due_asap: '尽快',
                last_updated: '最后更新',
                total: '总金额',
                type: '类别',
                table: '桌子',
                payment_method: '支付方式',
                payment_status: '支付状态',
                notes: '备注',
                name: '名字',
                email: '电子邮箱',
                phone: '电话',
                delivery_address: '配送地址',
                delivery_tracking: '配送状态查询',
                delivery_tracking_link: '实时查询链接',
                store_address: '商店地址',
            },
            dishes: {
                headings: {
                    quantity: '数量',
                    item: '商品',
                    price: '价格',
                },
                notes: '备注',
                remove_ingredients: '删除配料',
            },
            status_update: {
                title: '订单号 {{number}} 已更新',
                body: '您的订单状态已更新为 {{status}}',
            },
            wait_time_update: {
                title: '订单号 {{number}} 已更新',
                body: '您的订单到期时间已更新',
            },
            delivery_update: {
                title: '订单号 {{number}} 已更新',
                body: '您的订单已安排配送。查看实时查询链接。',
            },
            payment_status_update: {
                title: '订单号 {{number}} 已更新',
                body: '您的订单付款状态已更新。',
            },
            email_new_order_restaurant: {
                subject: "新订单 ({{number}}) - {{name}}",
                powered_by: "Powered By {{name}}",
                overview: "新订单通知",
                title: "在 {{name}} 下的新订单",
                subtitle: "订单号 {{number}}",
                description: "通过您的管理仪表板查看详细信息和更新",
                button_text: "跟踪订单",
                track_delivery_button_text: "跟踪交付",
            },
            email_new_order_customer: {
                subject: "新订单 ({{number}})",
                powered_by: "Powered By {{name}}",
                overview: "新订单通知",
                title: "在 {{name}} 下的新订单",
                subtitle: "订单号 {{number}}",
                description: "通过您的实时在线收据查看详细信息和更新。",
                button_text: "跟踪订单",
                track_delivery_button_text: "跟踪交付",
            },
        },
        totals: {
            tax: "{{name}} ({{percent}}%)",
            tax_in_prices: "价格已包含 {{name}} ({{percent}}%) ",
            fee: "{{name}} ({{value, currency}} + {{percent}}%)",
            fee_percent: "{{name}} ({{percent}}%)",
            fee_fixed: "{{name}}",
            delivery_fee: "配送费",
            promo: "折扣: {{name}} ({{value, currency}} + {{percent}}% )",
            promo_percent: "折扣: {{name}} ({{percent}}%)",
            promo_fixed: "折扣: {{name}}",
            cart: "购物车",
            tip: "订单小费",
            total: "总金额",
        },
        status: {
            unconfirmed: "等待确认",
            awaiting_payment: "待付款",
            confirmed: "确认",
            ready: "准备好了",
            on_route: "在路上",
            complete: "完成",
            cancelled: "取消",
            seated: "已入座",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "未可用",
                },
            },
            dish: {
                no_stock: "已售馨",
                not_available: "未可用",
            },
        },
    },
};
//# sourceMappingURL=zh.js.map